import Vue from 'vue';
import ApiService from '../lib/api';

const state = {
    modules: {}
};

const mutations = {
    setModule(store, payload) {
        Vue.set(store.modules, payload.name, payload);
    },
};

const actions = {
    loadModule({commit}, moduleName) {
        return new Promise(resolve => {
           ApiService.get('/modules/' + moduleName).then(resp => {
               commit('setModule', resp.data);
               resolve(resp.data);
           });
        });
    }
};

const getters = {
    getModuleContext: (state) => (moduleName) => {
        return state.modules[moduleName]?.context;
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};
